import styled, { css } from "styled-components/macro";

import type { ThemeProps } from "models/styles/theme";

import { ParagraphLarge } from "styles/elements/Texts";
import { CssFlex, CssIcon } from "styles/helpers/layout";

export type FeedbackMessageVariant = "info" | "error" | "success" | "warning";

interface Props extends ThemeProps {
  $variant: FeedbackMessageVariant;
}

export const StyledFeedbackMessage = styled(CssFlex)<Props>`
  width: 100%;
  padding: 1rem;
  text-align: left;

  ${(props: Props) => {
    switch (props.$variant) {
      case "success":
        return css`
          background: ${(props: Props) => props.theme.palette.feedback.success._950};
          border-left: solid 2px ${(props: Props) => props.theme.palette.feedback.success.brand};

          ${CssIcon} {
            color: ${(props: Props) => props.theme.palette.feedback.success.brand};
          }
        `;
      case "error":
        return css`
          background: ${(props: Props) => props.theme.palette.feedback.error._950};
          border-left: solid 2px ${(props: Props) => props.theme.palette.feedback.error.brand};

          ${CssIcon} {
            color: ${(props: Props) => props.theme.palette.feedback.error.brand};
          }
        `;
      case "warning":
        return css`
          background: ${(props: Props) => props.theme.palette.yellow._999};
          border-left: solid 2px ${(props: Props) => props.theme.palette.yellow.brand};

          ${CssIcon} {
            color: ${(props: Props) => props.theme.palette.yellow.brand};
          }
        `;
      default:
        return css`
          background: ${(props: Props) => props.theme.palette.feedback.info._999};
          border-left: solid 2px ${(props: Props) => props.theme.palette.feedback.info.brand};

          ${CssIcon} {
            color: ${(props: Props) => props.theme.palette.feedback.info.brand};
          }
        `;
    }
  }}

  ${ParagraphLarge} {
    font-weight: bold;
    line-height: 100%;
  }

  a {
    color: ${(props: Props) => props.theme.palette.primary.brand};
    text-decoration: none;

    :hover {
      color: ${(props: Props) => props.theme.palette.primary._600};
    }
  }
`;
